/** SessionStorage key for the short-lived JWT returned by Stripe onboarding validate. Used to authorize CompleteStripeRegistration. */
export const STRIPE_ONBOARDING_TOKEN_KEY = 'stripeOnboardingToken';
